<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card-widget title="Informações">
          <div slot="widget-content">
            <v-row no-gutters>
              <v-col cols="6">
                <span class="font-weight-bold">Usuário: </span>
                <span class="font-weight-light">{{ usuario.nome }}</span>
              </v-col>
              <v-col
                v-if="unidade.id"
                cols="6"
              >
                <span class="font-weight-bold">Unidade: </span>
                <span class="font-weight-light">{{
                  `${unidade.sigla} - ${unidade.nome}`
                }}</span>
              </v-col>
            </v-row>
          </div>
        </v-card-widget>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card-widget
          :enable-actions="false"
          title="Programação do Diagnóstico"
        >
          <div slot="widget-content">
            <v-row no-gutters>
              <v-col cols="12">
                <diagnostico-form
                  :diagnostico="diagnostico"
                  :is-edicao="isEdicao"
                  :reset-form="resetForm"
                  @diagnostico="(value) => (diagnostico = value)"
                  @updating="(value) => (isEdicao = value)"
                  @resetForm="(value) => (resetForm = value)"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <diagnostico-list
                  modo="EDICAO"
                  @update="(value) => editar(value)"
                  @resetForm="(value) => (resetForm = value)"
                />
              </v-col>
            </v-row>
          </div>
        </v-card-widget>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VCardWidget from '@/components/VWidget';
import DiagnosticoForm from '@/components/diagnostico/DiagnosticoForm';
import DiagnosticoList from '@/components/diagnostico/DiagnosticoList';
import Data from '@/modules/data';

export default {
  name: 'ProgramacaoDiagnostico',

  components: { VCardWidget, DiagnosticoForm, DiagnosticoList },

  data() {
    return {
      diagnostico: {
        id: null,
        nome: '',
        ano: Data.get().year(),
        inicioComportamental: '',
        fimComportamental: '',
        inicioResponsabilidadeChefia: '',
        fimResponsabilidadeChefia: '',
        inicioResponsabilidadeServidor: '',
        fimResponsabilidadeServidor: '',
        inicioDesempenho: '',
        mapeamento: null,
      },
      isEdicao: false,
      resetForm: false,
    };
  },

  computed: {
    ...mapState({
      usuario: (state) => state.auth.usuario,
      unidade: (state) => state.auth.unidade,
      comissao: (state) => state.auth.comissao,
    }),
  },

  watch: {
    comissao(value) {
      if (!value) this.$router.push('403');
    },
  },

  updated() {
    if (!this.comissao) {
      this.$router.push('/403');
    }
  },

  methods: {
    editar(item) {
      this.isEdicao = true;
      this.diagnostico = { ...item };
    },
  },
};
</script>
